module.exports = "/_next/static/images/construction-49456c988f663973c21fa00a576803b4.png.webp";